import { deleteForUser, getForUser } from '@/services/listingDraftRepository';

export const LISTING_DRAFT_SCHEMA_VERSION = 1;
const checkedUsers = new Set();

export async function findRecoverableDraft(userUuid) {
  const draft = await getForUser(userUuid);
  if (!draft) return null;
  if (draft.schemaVersion !== LISTING_DRAFT_SCHEMA_VERSION || !draft.draftId || !draft.payload) {
    await deleteForUser(userUuid);
    return null;
  }
  return draft;
}

export async function chooseListingDraft(vm, userUuid) {
  const draft = await findRecoverableDraft(userUuid);
  if (!draft) return { choice: 'fresh', draft: null };

  const result = await vm.$swal({
    type: 'question',
    title: 'Draft Listing Ditemukan',
    text: 'Lanjutkan pengisian listing yang belum selesai?',
    confirmButtonText: 'Lanjutkan Draft',
    cancelButtonText: 'Buang Draft',
    showCancelButton: true,
    showCloseButton: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    reverseButtons: true,
  });

  if (result && result.value) return { choice: 'continue', draft };
  if (!result || result.dismiss !== 'cancel') return { choice: 'close', draft };
  await deleteForUser(userUuid);
  return { choice: 'discard', draft: null };
}

export async function checkListingDraftOnce(vm, userUuid) {
  if (!userUuid || checkedUsers.has(userUuid)) return { choice: 'checked', draft: null };
  checkedUsers.add(userUuid);
  return chooseListingDraft(vm, userUuid);
}

export function createDraftUuid() {
  if (typeof window !== 'undefined' && window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(16).slice(2)}-${Math.random()
    .toString(16)
    .slice(2)}`;
}
